import { apolloClient } from "../../../vue-apollo";
import { GET_SAFETY_DOCS_CATEGORIES, MODULOS } from "../../../apollo/queries";
/***
 * Este store controla las categorias de seguridad y biblioteca
 */
export default {
    namespaced: true,
    state: {
        safety_cat_list: [],
        library_cat_list: [],
    },
    mutations: {
        getSafeCategories(state, resp) {
            state.safety_cat_list = resp;
        },
        getLibraryCategories(state, resp) {
            state.library_cat_list = resp;
        },
        addSafeCat(state, cat) {
            state.safety_cat_list.unshift(cat);
        },
        addLibraryCat(state, cat) {
            state.library_cat_list.unshift(cat);
        },
        deleteSafeCat(state, idCat) {
            state.safety_cat_list = state.safety_cat_list.filter(
                (cat) => cat.id_categoria !== idCat
            );
        },
        deleteLibraryCat(state, idCat) {
            state.library_cat_list = state.library_cat_list.filter(
                (cat) => cat.id_categoria !== idCat
            );
        },
        editSafeCat(state, editedCat) {
            var index = state.safety_cat_list.findIndex(
                (doc) => doc.id_categoria == editedCat.id_categoria
            );
            if (index !== -1) {
                state.safety_cat_list.splice(index, 1, editedCat);
            }
        },
        editLibraryCat(state, editedCat) {
            var index = state.library_cat_list.findIndex(
                (doc) => doc.id_categoria == editedCat.id_categoria
            );
            if (index !== -1) {
                state.library_cat_list.splice(index, 1, editedCat);
            }
        },
    },
    actions: {
        // Obtener categorias de seguridad
        async getSafeCatsList({ commit }, data_) {
            const { data } = await apolloClient.query({
                query: GET_SAFETY_DOCS_CATEGORIES,
                variables: data_,
                fetchPolicy: "network-only",
            });
            const categories = data && data.CategoriasDocumentosAdmin ? data.CategoriasDocumentosAdmin : [];
            commit("getSafeCategories", categories);
            return categories;
        },
        // Obtener categorias de biblioteca
        async getLibraryCatsList({ commit }, data_) {
            const { data } = await apolloClient.query({
                query: GET_SAFETY_DOCS_CATEGORIES,
                variables: data_,
                fetchPolicy: "network-only",
            });
            const categories = data && data.CategoriasDocumentosAdmin ? data.CategoriasDocumentosAdmin : [];
            commit("getLibraryCategories", categories);
            return categories;
        },
        // Obtener lista general de módulos
        async getModulosAction() {
            const { data } = await apolloClient.query({
                query: MODULOS,
                fetchPolicy: "network-only",
            });
            return data && data.modulos ? data.modulos : [];
        },
        // Agregar categorias de seguridad
        async addSafeCatAction({ commit }, cat) {
            commit("addSafeCat", cat);
        },
        // Eliminar categorias de seguridad
        async deleteSafeCatAction({ commit }, id) {
            commit("deleteSafeCat", id);
        },
        // Editar categorias de seguridad
        async editSafeCatAction({ commit }, cat) {
            commit("editSafeCat", cat);
        },
        // Agregar categorias de biblioteca
        async addLibraryCatAction({ commit }, cat) {
            commit("addLibraryCat", cat);
        },
        // Eliminar categorias de biblioteca
        async deleteLibraryCatAction({ commit }, id) {
            commit("deleteLibraryCat", id);
        },
        // Editar categorias de biblioteca
        async editLibraryCatAction({ commit }, cat) {
            commit("editLibraryCat", cat);
        },
    },
};